(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

document.addEventListener('DOMContentLoaded', function () {
  return document.querySelectorAll('.hb-expandable').forEach(function (rootEl) {
    return initializeExpandable(rootEl);
  });
});
var initializeExpandable = function initializeExpandable(rootEl) {
  var togglerEl = rootEl.querySelector('[data-hb-expandable-toggler]');
  if (togglerEl === null) {
    throw new Error('Toggler element is not set. Check that you have "data-hb-expandable-toggler" attribute set on your toggling button');
  }
  var contentEl = rootEl.querySelector('[data-hb-expandable-content]');
  if (contentEl === null) {
    throw new Error('Expanding content element is not set. Check that you have "data-hb-expandable-content" attribute set on element you want to expand');
  }
  var content = initializeContent(contentEl);
  var root = initializeRoot(rootEl, content);
  initializeToggler(togglerEl, root);
};
var initializeRoot = function initializeRoot(el, content) {
  var ExpandedSelector = 'hb-expandable--expanded';
  var shouldExpandOnStart = function shouldExpandOnStart() {
    return !!el.dataset.hbExpandableExpanded;
  };
  var isExpanded = function isExpanded() {
    return el.classList.contains(ExpandedSelector);
  };
  var setExpanded = function setExpanded() {
    el.classList.add(ExpandedSelector);
    content.updateHeight();
  };
  var setCollapsed = function setCollapsed() {
    el.classList.remove(ExpandedSelector);
    content.removeHeight();
  };
  if (shouldExpandOnStart()) {
    setExpanded();
  }
  var onResize = function onResize() {
    return isExpanded() && content.updateHeight();
  };
  window.addEventListener('resize', onResize);
  return {
    toggleExpanded: function toggleExpanded() {
      return isExpanded() ? setCollapsed() : setExpanded();
    },
    removeResizeListener: function removeResizeListener() {
      return window.removeEventListener('resize', onResize);
    }
  };
};
var initializeToggler = function initializeToggler(el, root) {
  var _onClick = function onClick() {
    root.toggleExpanded();
    if (!!el.dataset.hbExpandableTogglerRemoveOnExpand) {
      el.removeEventListener('click', _onClick);
      root.removeResizeListener();
      el.remove();
    }
  };
  el.addEventListener('click', _onClick);
};
var initializeContent = function initializeContent(el) {
  var countRealHeightOf = function countRealHeightOf(el) {
    var paddingTop = parseInt(window.getComputedStyle(el).paddingTop); // there should be always something; parseInt() strips `px` from the end of the string and removes floating stuff as well
    var paddingBottom = parseInt(window.getComputedStyle(el).paddingBottom); // there should be always something; parseInt() strips `px` from the end of the string and removes floating stuff as well
    return el.scrollHeight + paddingTop + paddingBottom;
  };
  return {
    updateHeight: function updateHeight() {
      return el.style.setProperty('--height', countRealHeightOf(el) + 'px');
    },
    removeHeight: function removeHeight() {
      return el.style.removeProperty('--height');
    }
  };
};

},{}]},{},[1]);
